export const TEMPLATE_KEY = 'jsm.it-service-management-advanced' as const;
